import React, { useState, memo, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useAlert, types } from 'react-alert';
import Avatar from '@material-ui/core/Avatar';
import Rating from '@material-ui/lab/Rating';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Message, PrimaryButton, RateWithNumber } from '../../../components';
import * as Constants from '../../../common/constants';
import { useJobOfferDetail, useJobUser } from '../../../../model/hooks';
export const WriteReviewCard = memo((props) => {
    var _a, _b, _c, _d, _f, _g;
    const { appliedUser, setOpen } = props;
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const { postReview, loadingPostReview } = useJobOfferDetail();
    const { loadPostedReview, loadingPostedReview } = useJobUser();
    const [rate, setRate] = useState(0);
    const [reviewText, setReviewText] = useState('');
    const [postedReview, setPostedReview] = useState(undefined);
    useEffect(() => {
        const f = async () => {
            var _a, _b, _c;
            try {
                const result = await loadPostedReview((_a = appliedUser) === null || _a === void 0 ? void 0 : _a.workerId, (_b = appliedUser) === null || _b === void 0 ? void 0 : _b.detail.clinicId, (_c = appliedUser) === null || _c === void 0 ? void 0 : _c.detail.jobOfferId);
                setPostedReview(result);
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        f();
    }, [appliedUser]);
    const onChangeRate = (_e, val) => setRate(val);
    const onClickPostReview = async () => {
        var _a, _b;
        if (reviewText === '' || rate === 0) {
            reactAlert.show(t('全て入力してください'), { type: types.ERROR });
            return;
        }
        try {
            await postReview(rate, reviewText, (_a = appliedUser) === null || _a === void 0 ? void 0 : _a.detail.jobOfferId, (_b = appliedUser) === null || _b === void 0 ? void 0 : _b.workerId);
            reactAlert.show(t('レビューを登録しました'), { type: types.SUCCESS });
            setOpen(false);
        }
        catch (e) {
            if (e instanceof Error)
                reactAlert.show(e.message, { type: types.ERROR });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(STitle, null, t('レビューを書く')),
        loadingPostedReview ? (React.createElement(SLoadingArea, null,
            React.createElement(CircularProgress, null))) : (React.createElement(React.Fragment, null, postedReview ? (React.createElement(React.Fragment, null,
            React.createElement(SRow, { style: { paddingBottom: '24px' } },
                React.createElement(Avatar, { src: (_a = appliedUser) === null || _a === void 0 ? void 0 : _a.workerImageUrl, alt: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u753B\u50CF", style: { width: '60px', height: '60px' } }),
                React.createElement(SUserName, null, `${(_b = appliedUser) === null || _b === void 0 ? void 0 : _b.workerLastName} ${(_c = appliedUser) === null || _c === void 0 ? void 0 : _c.workerFirstName}`)),
            React.createElement(RateWithNumber, { value: postedReview.rating, size: "medium" }),
            React.createElement(SReviewText, null, postedReview.text),
            React.createElement(Message, { type: "info" }, t('レビューは登録済みです')))) : (React.createElement(React.Fragment, null,
            React.createElement(SRow, { style: { paddingBottom: '24px' } },
                React.createElement(Avatar, { src: (_d = appliedUser) === null || _d === void 0 ? void 0 : _d.workerImageUrl, alt: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u753B\u50CF", style: { width: '60px', height: '60px' } }),
                React.createElement(SUserName, null, `${(_f = appliedUser) === null || _f === void 0 ? void 0 : _f.workerLastName} ${(_g = appliedUser) === null || _g === void 0 ? void 0 : _g.workerFirstName}`)),
            React.createElement(Rating, { name: "rate", defaultValue: 0, precision: 0.5, value: rate, onChange: onChangeRate }),
            React.createElement(TextField, { label: t('レビュー内容'), fullWidth: true, required: true, defaultValue: reviewText, onChange: (e) => setReviewText(e.target.value) }),
            React.createElement(SButtonArea, null,
                React.createElement(PrimaryButton, { loading: loadingPostReview, disabled: reviewText === '' || rate === 0, onClick: onClickPostReview }, t('レビューする')))))))));
});
const STitle = styled.p `
  font-weight: bold;
  font-size: 18px;
`;
const SRow = styled.div `
  display: flex;
  align-items: center;
`;
const SUserName = styled.p `
  margin-left: 24px;
  margin-bottom: 0;
  color: ${Constants.COLOR.ORANGE700};
  font-weight: bold;
`;
const SButtonArea = styled.div `
  margin-top: 32px;
  text-align: center;
`;
const SLoadingArea = styled.div `
  padding-top: 32px;
  text-align: center;
`;
const SReviewText = styled.p `
  margin-top: 16px;
  margin-left: 8px;
  font-size: 16px;
`;
